module.exports = __webpack_public_path__ + "media/images/flags/16/Norway-3cc1c4fbdf419bc09b2d20b1a30c7a25.png";